<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<InventoryNavi />
			<div class="widget-location">
				<h3>입고신청</h3>
			</div>
				
			<el-row style="display: flex;justify-content: center;align-items: center;padding:0 40px;">
				<el-col :xs="16" :sm="8" >
					<el-input v-model="search" class="unit-input" placeholder="상품코드 또는 상품명" ></el-input>
				</el-col>
				<el-col :xs="8" :sm="8" style="display:flex;gap:10px;">
					<el-button type="primary" @click="onSearch" >불러오기</el-button>
					<el-button style="background-color: #F7941D; border-color: #F7941D; color: #fff;" @click="onInventoryDialog" >선택하기</el-button>
				</el-col>
			</el-row>
			
			<div class="item-info">
				<el-form :model="ruleForm"  ref="ruleForm" label-width="0" >	
					<!-- 动态表单项列表 -->
					<div 
						v-for="(item, index) in ruleForm.items" 
						:key="index" 
					>
						<div class="form-item" >
							<el-row>
								<el-col :xs="24" :sm="8"  class="item"><!--商品名称-->
									<div class="from-title">상품명(영문) <span class="required-addon">(*)</span></div>
									<el-form-item  :prop="`items.${index}.goods_name`"
									:rules="[
										{ required: true, message: '상품명 필수', trigger: 'blur' },
									]">
										<el-input v-model="item.goods_name" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										   <div>검색(HS코드네비게이션)에서 보다 정확한 결과를 얻을수 있습니다</div>
												<i class="el-icon-question icon-question" slot="reference"></i>
										</el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">상품코드 <span class="required-addon">(*)</span></div><!--商品代码-->
									<el-form-item  :prop="`items.${index}.code`" :rules="[
										{ required: true, message: '상품코드 필수', trigger: 'blur' },
									]">
										<el-input v-model="item.code" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										    <div>국내마켓 상품관리에 필요한 상품코드를 입력 관리해보세요</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">관리코드 </div><!-- 管理代码 -->
									<el-form-item  :prop="`items.${index}.refer_code`">
										<el-input v-model="item.refer_code" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										    <div>관리코드를 부여해서 관리해보세요</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">주문번호 <span class="required-addon">(*)</span></div><!-- 订单号 -->
									<el-form-item  :prop="`items.${index}.order_no`" :rules="[
										{ required: true, message: '주문번호 필수', trigger: 'blur' },
									]">
										<el-input v-model="item.order_no" class="input-frame" ></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										    <div>구매 주문번호를 입력해주세요</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">트래킹넘버 <span class="required-addon">(*)</span></div><!-- 快递单号 -->
									<el-form-item  :prop="`items.${index}.tracking_no`" :rules="[
										{ required: true, message: '트래킹넘버 필수', trigger: 'blur' },
									]">
										<el-input v-model="item.tracking_no" class="input-frame" placeholder="여러개 입력시 ,(콤마)"></el-input>
										<el-popover
										   placement="top-start"
										   width="300"
										   trigger="hover"
										   >
										    <div>판매자 상품발송후 제공된 트래킹번호를 즉시 입력해주세요<br>입력이 안될경우 노데이터로 분류되어서 입고가 지연됩니다</div>
											<i class="el-icon-question icon-question" slot="reference"></i>
										 </el-popover>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">수량 <span class="required-addon">(*)</span></div><!-- 数量 -->
									<el-form-item  :prop="`items.${index}.apply_quantity`"
									:rules="[
										{ required: true, message: '수량 필수', trigger: 'blur' },
									]">
										<el-input-number v-model="item.apply_quantity" :min="1" :precision="0" :controls="false" class="num-input-left" style="width: 200px; margin: 0 10px;"></el-input-number>
										개
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">요청메세지 </div><!-- 发货备注 -->
									<el-form-item  :prop="`items.${index}.shipping_memo`"
									>
										<el-input v-model="item.shipping_memo" placeholder="30자 이내로 적어주세요."  class="input-frame"  ></el-input>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :sm="8"  class="item">
									<div class="from-title">쉬핑네임 </div><!-- 购物昵称 -->
									<el-form-item  :prop="`items.${index}.ship_name`" >
										<el-input v-model="item.ship_name"  class="input-frame" ></el-input>
									</el-form-item>
								</el-col>
								
								
								<el-col :xs="24" :sm="8"  class="item">
									<el-form-item>
									  <el-button 
										type="danger" 
										icon="el-icon-delete" 
										@click="removeItem(index)"
										:disabled="ruleForm.items.length <= 1"
									  >
										삭제
									  </el-button>
									  <el-button
										type="primary" 
										icon="el-icon-plus" 
										@click="addItem"
									  >
										상품추가
									  </el-button>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
					</div>
				</el-form>
			</div>

			<div style="text-align: center;margin: 0 0 30px;">
				<el-button  type="primary" @click="submitForm" round>등록하기</el-button>		
			</div>
			
			
		</div>
		
		<!--재고상품 선택 弹窗-->
		<el-dialog title="재고상품 선택하기" :visible.sync="inventoryVisible" :width="isMobile?'96%':'70%'" :close-on-click-modal="false">
			<!--搜索条件-->
			<div style="margin-bottom:15px;">
				<el-row :gutter="10">
					<el-col :xs="12" :sm="6" style="margin-bottom:10px;">
						<el-input v-model="inv_code" placeholder="상품코드" size="small" clearable></el-input>
					</el-col>
					<el-col :xs="12" :sm="6" style="margin-bottom:10px;">
						<el-input v-model="inv_barcode" placeholder="바코드" size="small" clearable></el-input>
					</el-col>
					<el-col :xs="12" :sm="6" style="margin-bottom:10px;">
						<el-input v-model="inv_goods_name" placeholder="상품명" size="small" clearable></el-input>
					</el-col>
					<el-col :xs="12" :sm="6" style="margin-bottom:10px;">
						<el-button type="primary" size="small" @click="onInvSearch">검색</el-button>
						<el-button size="small" @click="onInvReset">초기화</el-button>
					</el-col>
				</el-row>
			</div>
			<!--PC端表格-->
			<div v-if="!isMobile">
				<div style="display:flex; justify-content:space-between; align-items:flex-end; margin-bottom:10px;">
					<div style="font-size:14px;font-weight:bold;">
						전체 : <strong style="color:var(--main-color);">{{inv_total}}</strong> ({{inv_current_page}}/{{inv_last_page}} 페이지)
					</div>
					<el-button style="background-color: #F7941D; border-color: #F7941D; color: #fff;" size="small" @click="onMultiSelectInventory">선택완료</el-button>
				</div>
				<el-table ref="inventoryTable" :data="inventoryData" @selection-change="handleSelectionChange" stripe empty-text="데이타가 없습니다." style="width:100%;" max-height="400">
					<el-table-column type="selection" width="55" align="center"></el-table-column>
					<el-table-column label="상품코드" width="120">
						<template slot-scope="scope">
							<div style="font-weight:bold;">{{scope.row.code}}</div>
						</template>
					</el-table-column>
					<el-table-column label="상품정보" min-width="200">
						<template slot-scope="scope">
							<div><a style="color:#333;font-weight:500;text-decoration:none;" :href="scope.row.url" target="_blank">{{ scope.row.goods_name }}</a></div>
							<div style="font-size:12px;color:#999;">
								<span v-if="scope.row.price">단가:{{ scope.row.price }} CNY,</span>
								<span v-if="scope.row.color">색상:{{scope.row.color}},</span>
								<span v-if="scope.row.size">사이즈:{{scope.row.size}},</span>
								<span v-if="scope.row.barcode">바코드:{{scope.row.barcode}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="입고신청 / 입고 / 발송신청 / 잔여" width="220" align="center">
						<template slot-scope="scope">
							<div style="font-size:12px;">
								<span style="color:#0055d4;">{{scope.row.warehouse_apply}}</span> / 
								{{scope.row.warehouse_num}} / 
								{{scope.row.shipping_apply}} / 
								<strong>{{scope.row.remaining_quantity}}</strong>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="" width="80" align="center">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="onSelectInventory(scope.row)">선택</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!--移动端卡片列表-->
			<div v-else style="max-height:400px;overflow-y:auto;">
				<div style="display:flex; justify-content:space-between; align-items:flex-end; margin-bottom:10px;">
					<div style="font-size:14px;font-weight:bold;">
						전체 : <strong style="color:var(--main-color);">{{inv_total}}</strong>
					</div>
					<el-button style="background-color: #F7941D; border-color: #F7941D; color: #fff;" size="small" @click="onMultiSelectInventory">선택완료</el-button>
				</div>
				<div v-for="(item,index) in inventoryData" :key="index" style="border:1px solid #eee;border-radius:8px;padding:10px;margin-bottom:10px; position:relative;">
					<div style="position:absolute; top:10px; right:10px;">
						<el-checkbox v-model="item.checked" @change="handleMobileSelectionChange(item)"></el-checkbox>
					</div>
					<div style="font-weight:bold;font-size:13px;margin-bottom:5px; padding-right:25px;">
						<span style="color:var(--main-color);">[{{item.code}}]</span> {{item.goods_name}}
					</div>
					<div style="font-size:12px;color:#666;margin-bottom:8px;">
						<span v-if="item.price">단가:{{item.price}} CNY,</span>
						<span v-if="item.color">색상:{{item.color}},</span>
						<span v-if="item.size">사이즈:{{item.size}}</span>
					</div>
					<div style="display:flex;justify-content:space-between;align-items:center;">
						<span style="font-size:12px;">잔여: <strong>{{item.remaining_quantity}}</strong></span>
						<el-button size="mini" type="primary" @click="onSelectInventory(item)">선택</el-button>
					</div>
				</div>
			</div>
			<!--分页-->
			<div style="text-align:center;padding-top:15px;">
				<el-pagination
					layout="prev, pager, next" :page-size="20"
					:total="inv_total" @current-change="onInvPageChange">
				</el-pagination>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				search:"",
				
				ruleForm: {
					items: [],	
				},
				// 재고상품 선택 弹窗相关变量
				inventoryVisible: false,
				inventoryData: [],
				inv_code: '',
				inv_barcode: '',
				inv_goods_name: '',
				inv_total: 0,
				inv_current_page: 1,
				inv_last_page: 1,
				inv_page: 1,
				inv_selected_items: [], // 选中的商品列表
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},	
		created(){
			// 初始化时添加一个空表单项
			this.addItem()
		},
		methods: {
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
		
						this.$confirm('정말 상품을 등록하겠습니까?', '', {
						  confirmButtonText: '확인',
						  cancelButtonText: '취소',
						  type: 'warning'
						}).then(() => {
							const submitData = {
								items: [...this.ruleForm.items]
							}
							console.log(this.ruleForm.items,"结果1")
							console.log(submitData,"结果")
							request.post('/member/Inventory/warehouseApplication',
								submitData
							).then(response => {
								console.log(response,"注册")			  
								if(response.code ==1){
									alert('정상적으로 등록되었습니다.');
									console.log('提交成功！');
									if (this.$route.query.type === 'coupang' || this.$route.query.activeMenu) {
										this.$router.replace({ query: { ...this.$route.query, type: 'coupang', activeMenu: 'coupang_inventory_warehouse' } }).catch(() => {});
									} else {
										this.$router.replace('/inventoryWarehouse').catch(() => {});
									}
								}else{
									alert(response.msg)
									console.log(response,'12111');
									return
								}
							});
								
						}).catch(() => {});
		
						
					} else {
						console.log('error submit!!');
						return false;
					}
					
				})
				
		
			},
			addItem(){
				this.ruleForm.items.push({
					inventory_id:'',
					goods_name:'',
					code:'',
					refer_code:'',
					order_no:'',
					tracking_no:'',
					apply_quantity: undefined,
					shipping_memo:'',
					ship_name:'',
					
					
				
				})
			},
			/**
			 * 删除指定索引的表单项
			 * @param {Number} index - 要删除的表单项索引
			 */
			removeItem(index) {
				this.ruleForm.items.splice(index, 1)
			},
			onSearch(){
				request.post('/member/Inventory/warehouseVerify',{
					search:this.search
				})
				.then(res => {
					console.log(res,"212")
					if(res.code ==1){
						
						
						// 删除 空项
						const ruleForm = this.ruleForm.items.filter(item => {
						  // 返回 true 的项会被保留，false 的项会被过滤（即“删除”）		 
						  return item.goods_name!=="" && item.code!==""; 
						});
						
						this.ruleForm.items = ruleForm
						this.ruleForm.items.push({
							inventory_id:res.data.id,
							goods_name:res.data.goods_name,
							code:res.data.code,
							refer_code:'',
							order_no:'',
							tracking_no:'',
							apply_quantity: undefined,
							shipping_memo:'',
							ship_name:'',
						})
						
						
					}else{
						alert(res.msg)
						return
					}
						
				});
				
			},
			/**
			 * 打开재고상품선택弹窗
			 */
			onInventoryDialog(){
				this.inventoryVisible = true
				this.inv_page = 1
				this.getInventoryList()
			},
			/**
			 * 获取库存商品列表
			 */
			getInventoryList(){
				request.post('/member/Inventory/getGoodsList',{
					page: this.inv_page,
					code: this.inv_code,
					barcode: this.inv_barcode,
					goods_name: this.inv_goods_name,
				}).then(res => {
					if(res.code == 1){
						this.inv_total = res.data.total
						this.inv_current_page = res.data.current_page
						this.inv_last_page = res.data.last_page
						this.inventoryData = res.data.data
					}
				});
			},
			onInvSearch(){
				this.inv_page = 1
				this.getInventoryList()
			},
			onInvReset(){
				this.inv_code = ''
				this.inv_barcode = ''
				this.inv_goods_name = ''
				this.inv_page = 1
				this.getInventoryList()
			},
			onInvPageChange(val){
				this.inv_page = val
				this.getInventoryList()
			},
			/**
			 * PC端表格选择项发生变化
			 */
			handleSelectionChange(val) {
				this.inv_selected_items = val;
			},
			/**
			 * 移动端卡片选择项发生变化
			 */
			handleMobileSelectionChange(selectedItem) {
				if(selectedItem.checked) {
					// 避免重复添加
					if(!this.inv_selected_items.find(item => item.id === selectedItem.id)) {
						this.inv_selected_items.push(selectedItem);
					}
				} else {
					this.inv_selected_items = this.inv_selected_items.filter(item => item.id !== selectedItem.id);
				}
			},
			/**
			 * 批量选择库存商品，将选中的商品填入当前表单项
			 */
			onMultiSelectInventory(){
				if(this.inv_selected_items.length === 0) {
					this.$message.warning('선택된 상품이 없습니다.');
					return;
				}
				
				// 删除空项
				this.ruleForm.items = this.ruleForm.items.filter(item => {
					return item.goods_name !== '' && item.code !== ''
				})
				
				this.inv_selected_items.forEach(row => {
					this.ruleForm.items.push({
						inventory_id: row.id,
						goods_name: row.goods_name || '',
						code: row.code || '',
						refer_code: '',
						order_no: '',
						tracking_no: '',
						apply_quantity: undefined,
						shipping_memo: '',
						ship_name: '',
					});
				});
				
				this.$message.success(`${this.inv_selected_items.length}개 상품이 추가되었습니다.`);
				this.inventoryVisible = false;
				this.inv_selected_items = []; // 重置选中项
				if (this.$refs.inventoryTable) {
					this.$refs.inventoryTable.clearSelection(); // 清空PC端表格选中状态
				}
			},
			/**
			 * 单选库存商品，将商品信息填入当前表单项 (保留原本的单选按钮功能)
			 * @param {Object} row - 选中的库存商品数据
			 */
			onSelectInventory(row){
				// 删除空项
				this.ruleForm.items = this.ruleForm.items.filter(item => {
					return item.goods_name !== '' && item.code !== ''
				})
				
				this.ruleForm.items.push({
					inventory_id: row.id,
					goods_name: row.goods_name || '',
					code: row.code || '',
					refer_code: '',
					order_no: '',
					tracking_no: '',
					apply_quantity: undefined,
					shipping_memo: '',
					ship_name: '',
				})
				this.$message.success('상품이 추가되었습니다.')
				this.inventoryVisible = false
				this.inv_selected_items = []; 
				if (this.$refs.inventoryTable) {
					this.$refs.inventoryTable.clearSelection();
				}
			},
		}
		
	}
	
</script>

<style scoped>
	.widget-location {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center !important;
		border-bottom: 1.5px solid #eff3f9 !important;
		padding-bottom: 15px !important;
		margin-top: 5px !important;
		margin-bottom: 25px !important;
	}

	/* Top search controls card */
	.content-zsy > .el-row {
		background: #ffffff !important;
		border: 1px solid #eff3f9 !important;
		border-radius: 12px !important;
		padding: 10px 18px !important;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02) !important;
		margin-bottom: 25px !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		gap: 12px !important;
		width: 100% !important;
	}
	.content-zsy > .el-row > .el-col {
		width: auto !important;
		padding: 0 !important;
	}
	.unit-input {
		width: 320px !important;
	}
	::v-deep .unit-input .el-input__inner {
		height: 38px !important;
		line-height: 38px !important;
		border-radius: 8px !important;
		border-color: #cbd5e1 !important;
	}
	::v-deep .unit-input .el-input__inner:focus {
		border-color: #ff5700 !important;
	}
	.content-zsy > .el-row .el-button {
		height: 38px !important;
		border-radius: 8px !important;
		font-weight: 700 !important;
		font-size: 13px !important;
		padding: 0 22px !important;
		transition: all 0.2s ease !important;
		margin: 0 !important;
	}
	.content-zsy > .el-row .el-button--primary {
		background-color: #3b82f6 !important;
		border-color: #3b82f6 !important;
		box-shadow: 0 4px 10px rgba(59, 130, 246, 0.15) !important;
	}
	.content-zsy > .el-row .el-button--primary:hover {
		background-color: #2563eb !important;
		box-shadow: 0 6px 14px rgba(59, 130, 246, 0.25) !important;
	}

	/* Compact Card Container */
	.item-info {
		margin-top: 20px !important;
	}
	.item-info .form-item {
		background: #ffffff !important;
		border: 1px solid #eff3f9 !important;
		border-radius: 12px !important;
		padding: 16px 14px !important;
		margin-bottom: 20px !important;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.01) !important;
	}

	/* Flex wrapper to kill floated columns wrapping bug */
	.form-item > .el-row {
		display: flex !important;
		flex-wrap: wrap !important;
		margin-left: -8px !important;
		margin-right: -8px !important;
	}

	/* Tight Grid Items */
	.item-info .item {
		display: flex !important;
		flex-direction: column !important;
		align-items: flex-start !important;
		padding: 6px 8px !important;
		box-sizing: border-box !important;
		margin-bottom: 10px !important;
		float: none !important;
	}

	/* Tiny, Crisp置顶标签 */
	.from-title {
		font-size: 12px !important;
		font-weight: 700 !important;
		color: #4a5568 !important;
		margin-bottom: 4px !important;
		width: 100% !important;
		display: flex !important;
		align-items: center !important;
		justify-content: flex-start !important;
		height: 18px !important;
	}
	.required-addon {
		color: #ef4444 !important;
		margin-left: 2px !important;
	}

	/* Compact input component wrapper */
	.input-frame {
		width: 100% !important;
		margin: 0 !important;
	}
	::v-deep .el-input__inner {
		border-radius: 6px !important;
		border-color: #cbd5e1 !important;
		height: 32px !important;
		line-height: 32px !important;
		font-size: 12px !important;
		padding: 0 10px !important;
		transition: all 0.2s ease !important;
	}
	::v-deep .el-input__inner:focus {
		border-color: #ff5700 !important;
	}

	/* Quantity Input Number block adjustments */
	::v-deep .num-input-left {
		width: 100% !important;
		margin: 0 !important;
	}
	::v-deep .num-input-left .el-input__inner {
		text-align: left !important;
		padding-left: 10px !important;
	}
	
	/* Tiny layout helper */
	.el-form-item {
		margin-bottom: 0 !important;
		width: 100% !important;
	}
	::v-deep .el-form-item__content {
		display: flex !important;
		align-items: center !important;
		width: 100% !important;
		gap: 6px !important;
		color: #718096 !important;
		font-weight: 600 !important;
		font-size: 12px !important;
	}

	/* Tight validation layout to prevent grid height expansion */
	::v-deep .el-form-item__error {
		font-size: 11px !important;
		padding-top: 2px !important;
		position: relative !important;
		margin-top: 2px !important;
		display: block !important;
		width: 100% !important;
	}

	/* Help tooltip icons */
	.icon-question {
		color: #94a3b8 !important;
		font-size: 14px !important;
		cursor: pointer !important;
		margin-left: 2px !important;
		transition: color 0.2s ease !important;
	}
	.icon-question:hover {
		color: #ff5700 !important;
	}

	/* Form action buttons columns layout */
	.form-item .el-form-item {
		display: flex !important;
		justify-content: flex-end !important;
		gap: 10px !important;
		width: 100% !important;
		margin-top: 22px !important;
	}
	.form-item .el-form-item .el-form-item__content {
		display: flex !important;
		justify-content: flex-end !important;
		gap: 10px !important;
		width: 100% !important;
	}
	.form-item .el-form-item .el-button {
		height: 32px !important;
		line-height: 32px !important;
		border-radius: 6px !important;
		font-weight: 700 !important;
		font-size: 12px !important;
		transition: all 0.2s ease !important;
		margin: 0 !important;
		padding: 0 16px !important;
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.form-item .el-form-item .el-button--danger {
		background-color: #fee2e2 !important;
		border-color: #fca5a5 !important;
		color: #ef4444 !important;
	}
	.form-item .el-form-item .el-button--danger:hover {
		background-color: #fecaca !important;
		border-color: #ef4444 !important;
	}
	.form-item .el-form-item .el-button--primary {
		background-color: #3b82f6 !important;
		border-color: #3b82f6 !important;
		color: #ffffff !important;
		box-shadow: 0 3px 6px rgba(59, 130, 246, 0.1) !important;
	}
	.form-item .el-form-item .el-button--primary:hover {
		background-color: #2563eb !important;
		border-color: #2563eb !important;
		box-shadow: 0 4px 10px rgba(59, 130, 246, 0.2) !important;
	}

	/* Bottom register button */
	.item-info + div {
		text-align: center !important;
		margin: 30px 0 !important;
	}
	.item-info + div .el-button--primary {
		width: 200px !important;
		height: 46px !important;
		border-radius: 23px !important;
		font-weight: 700 !important;
		font-size: 15px !important;
		background: #ff5700 !important;
		border-color: #ff5700 !important;
		box-shadow: 0 6px 20px rgba(255, 87, 0, 0.2) !important;
		transition: all 0.3s ease !important;
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
		padding: 0 !important;
	}
	.item-info + div .el-button--primary:hover {
		background: #e04e00 !important;
		box-shadow: 0 10px 30px rgba(255, 87, 0, 0.35) !important;
		transform: translateY(-2px) !important;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy {
			width: 1270px !important;
			margin: 2.5rem auto !important;
		}
	}
	@media (max-width: 768px) {
		.content-zsy {
			margin-bottom: 40px !important;
		}
		.widget-location h3 {
			font-size: 26px !important;
			font-weight: bold !important;
			margin: 0 !important;
			word-break: keep-all !important;
		}
		.item-info .item {
			padding: 8px 12px !important;
		}
		.from-title {
			width: 100% !important;
			font-size: 12px !important;
		}
	}
</style>